import { render, staticRenderFns } from "./V6SlideSponsor.vue?vue&type=template&id=bf9b1068&scoped=true&"
import script from "./V6SlideSponsor.vue?vue&type=script&lang=js&"
export * from "./V6SlideSponsor.vue?vue&type=script&lang=js&"
import style0 from "./V6SlideSponsor.vue?vue&type=style&index=0&id=bf9b1068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b1068",
  null
  
)

export default component.exports